
### views/TravelRoutes.vue

```vue
<template>
  <div class="coming-soon">
    <div class="coming-soon-icon">🚧</div>
    <h2 class="coming-soon-title">大旅行调查路线与人员</h2>
    <p class="coming-soon-text">
      本部分正在建设中，将收录东亚同文书院学生在中国各地进行大旅行调查的详细路线、参与人员及相关资料。
      敬请期待！
    </p>
  </div>
</template>

<script>
export default {
  name: 'TravelRoutes'
}
</script>

<style scoped>
.coming-soon {
  text-align: center;
  padding: 50px 20px;
}

.coming-soon-icon {
  font-size: 5rem;
  color: var(--primary-color);
  margin-bottom: 20px;
}

.coming-soon-title {
  font-size: 1.8rem;
  color: var(--primary-dark);
  margin-bottom: 15px;
}

.coming-soon-text {
  font-size: 1.1rem;
  color: var(--secondary-color);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .coming-soon-icon {
    font-size: 3.5rem;
  }

  .coming-soon-title {
    font-size: 1.5rem;
  }

  .coming-soon-text {
    font-size: 1rem;
  }
}
</style>